/**
 * USDA Rural-Urban Commuting Area (RUCA) Codes 2020 — thin wrapper
 * Generated by data_raw/convert_usda_data.R on 2026-04-02
 * Data: 41146 ZCTAs in public/data/ruca.json
 *
 * Source: USDA Economic Research Service
 * https://www.ers.usda.gov/data-products/rural-urban-commuting-area-codes/
 */

let _data = null;
let _loadPromise = null;

export function loadRucaData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/ruca.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load RUCA data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getRUCAForZcta(zcta) {
  if (!_data || !zcta) return null;
  return _data[String(zcta).trim().substring(0, 5)] ?? null;
}

// Map per Methodology page exhibit and R replication snippet (Researchers §5).
// Draft index — values may change before peer review.
const RUCA_SCORE_MAP = {
  1: 8,  2: 15, 3: 24,
  4: 38, 5: 48, 6: 56,
  7: 68, 8: 76, 9: 84,
  10: 95,
};

export function rucaToScore(ruca) {
  return RUCA_SCORE_MAP[ruca] ?? null;
}

export function getRUCADescription(ruca) {
  const d = {
    1:  "Metropolitan area core",
    2:  "Metropolitan area — high commuting",
    3:  "Metropolitan area — low commuting",
    4:  "Micropolitan (small city) core",
    5:  "Micropolitan area — high commuting",
    6:  "Micropolitan area — low commuting",
    7:  "Small town core",
    8:  "Small town — high commuting",
    9:  "Small town — low commuting",
    10: "Rural — no significant urban commuting"
  };
  return d[ruca] ?? "Unknown classification";
}

export function isRuralByRUCA(ruca) { return ruca >= 4; }

const rucaZcta = { getRUCAForZcta, rucaToScore, getRUCADescription, isRuralByRUCA };
export default rucaZcta;
